import * as React from 'react';

function SvgEnlarge(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.467 16.523a.7.7 0 01-.99 0l9.361-10.351a.698.698 0 01.99 0 .696.696 0 01.205.488v6.207a.7.7 0 11-1.4 0v-4.51l-8.166 8.166zm9.566 6.81v-6.477a.7.7 0 10-1.4 0v5.777H7.368V7.367h5.789a.7.7 0 100-1.4h-6.49a.7.7 0 00-.7.7v16.666a.7.7 0 00.7.7h16.667a.7.7 0 00.7-.7z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgEnlarge;
